module.exports = __webpack_public_path__ + "static/img/11.23bad39.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/eng/11.png
// module id = Lh38
// module chunks = 0